function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable arrow-body-style */
import React from 'react';
import { styled } from '@mui/system';
import colors from '../../theme/colors.js';
const CardBlockStyled = styled('div')(({
  theme
}) => ({
  '&:hover': {
    borderLeft: `5px solid ${theme.palette.primary.main}`
  },
  backgroundColor: colors.surface,
  borderLeft: `${colors.surface} solid 5px`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  marginBottom: '8px',
  minHeight: '90px',
  padding: '20px 30px 2px 25px',
  position: 'relative',
  zIndex: 4
}));
const CardBlock = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    customStyle
  } = props;
  return /*#__PURE__*/React.createElement(CardBlockStyled, _extends({
    sx: customStyle,
    ref: ref
  }, props), children);
});
export default CardBlock;